import React, { useState, useEffect } from "react";
import GenderModel from "../ModelLayouts/GenderModel";
import GenderPopup from "../../components/PopUps/GenderPopup";
import { Link } from "react-router-dom";
import Overview from "../DetailsSubSections/Gender/Overview";
import GenderHealth from "../DetailsSubSections/Gender/GenderHealth";
import GenderInequality from "../DetailsSubSections/Gender/GenderInequality";
import Countries from "../DetailsSubSections/Gender/Countries";
import GenderWithinNoora from "../DetailsSubSections/Gender/GenderWithinNoora";
import ViewDocument from "../ui/ViewDocument";
import Icon from "../ui/Icon";
import FootInfo from "../ui/FootInfo";
import Magnifier from "../ui/Magnifier";
import GenderMobileModel from "../ModelLayouts/GenderMobileModel";

const GenderDetail = ({ isTabLoading }) => {
  const [showInfo, setShowInfo] = useState(false);
  const [isAutoOpen, setIsAutoOpen] = useState(false);
  const [clickOrigin, setClickOrigin] = useState("center right");
  const aboutIconRef = React.useRef(null);

  useEffect(() => {
    const hasViewed = sessionStorage.getItem("viewed_gender_popup");
    if (!hasViewed) {
      if (aboutIconRef.current) {
        const rect = aboutIconRef.current.getBoundingClientRect();
        setClickOrigin(
          `${rect.left + rect.width / 2}px ${rect.top + rect.height / 2}px`,
        );
      }
      setShowInfo(true);
      setIsAutoOpen(true);
      sessionStorage.setItem("viewed_gender_popup", "true");
    }
  }, []);

  const handleClose = () => {
    setShowInfo(false);
  };

  const handleExplore = () => {
    setShowInfo(false);
  };

  const handleManualOpen = (e) => {
    if (e && e.currentTarget) {
      const rect = e.currentTarget.getBoundingClientRect();
      setClickOrigin(
        `${rect.left + rect.width / 2}px ${rect.top + rect.height / 2}px`,
      );
    } else {
      setClickOrigin("center right");
    }
    setIsAutoOpen(false);
    setShowInfo(true);
  };

  const scrollToSectionEnd = () => {
    const element = document.getElementById("read-more-section");
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <div className="">
      {/* Infographic Section */}
      <div className="lg:mb-20">
        <div className="flex items-center justify-between mt-2 lg:hidden">
          <img
            src="/assets/svgs/countrys.svg"
            alt="Countries"
            className="w-auto h-auto [zoom:0.7]"
          />
          <div className="flex gap-3">
            <button ref={aboutIconRef} onClick={handleManualOpen}>
              <Icon src="/assets/svgs/about.svg" alt="About" />
            </button>
            <button onClick={scrollToSectionEnd}>
              <Icon
                src="/assets/svgs/back_btn.svg"
                alt="Bottom button"
                className="-rotate-90"
              />
            </button>
          </div>
        </div>

        <section className="block lg:hidden">
          <div className="">
            {/* <img
              src="/assets/img/mobile-layout/mobile-gender.png"
              alt="Gender mobile"
            /> */}
            <GenderMobileModel
              className="[zoom:0.55] xs:[zoom:0.7] sm:[zoom:1]"
              isParentLoading={isTabLoading}
              isPopUpOpen={showInfo}
            />
          </div>
        </section>

        <section className="relative hidden lg:block">
          <GenderModel className="[zoom:0.7] xl:[zoom:1]" />
          <div className="absolute top-1/2 -translate-y-1/2 right-5 z-10">
            <div className="flex gap-3">
              <button ref={aboutIconRef} onClick={handleManualOpen}>
                <Icon src="/assets/svgs/about.svg" alt="About" />
              </button>
              <button onClick={scrollToSectionEnd}>
                <Icon
                  src="/assets/svgs/back_btn.svg"
                  alt="Bottom button"
                  className="-rotate-90"
                />
              </button>
            </div>
          </div>
        </section>
      </div>

      <section
        className="grid lg:grid-cols-2 gap-5 scroll-mt-24"
        id="read-more-section"
      >
        <div className="hidden lg:block lg:col-span-1 h-fit sticky top-24 self-start">
          <div className="relative">
            <div className="[zoom:0.6] xl:[zoom:0.75] 2xl:[zoom:0.8]">
              <Magnifier
                zoomScale={3}
                lensSize={180}
                zoomPanelClassName="w-[840px] 2xl:w-[1000px] h-[900px]"
              >
                <GenderModel
                  className="[zoom:0.7] xl:[zoom:0.75] 2xl:[zoom:0.8]"
                  showTooltips={false}
                />
              </Magnifier>
            </div>
            <div>
              <div className="absolute right-2 xl:right-5 top-0 xl:top-10 [zoom:0.7] xl:[zoom:0.8]">
                {/* Country image at top */}
                <img
                  src="/assets/svgs/countrys.svg"
                  alt="Countries"
                  className="w-auto h-auto"
                />
              </div>
              <div className="absolute bottom-5 right-5 z-10">
                <Link to="/zoom-in-gender">
                  <Icon
                    src="/assets/svgs/zoomIn_btn.svg"
                    alt="Zoom in button"
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-1">
          <div className="space-y-12">
            <Overview />
            <GenderHealth />
            <GenderInequality />
            <Countries />
            <GenderWithinNoora />
            <ViewDocument
              description="This document has examples of some interventions across the world which aim to bridge the gender gap in caregiving"
              documentUrl="https://sapient-dev-bucket-projects.s3.ap-south-1.amazonaws.com/noora-health/uploads/51613093520503879942.Addressing-gender-inequality-in-caregiving_-Good-practices.pdf"
            />
            {/* <div className="flex items-center justify-end">
              <a
                href="https://drive.google.com/file/d/1KMRtxuuswOSlU4vfeenInacNaUn4zQCx/view?usp=drive_link"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue underline"
              >
                <Icon src="/assets/svgs/ref.svg" alt="Refrence icon" />
              </a>
            </div> */}
            <FootInfo />
          </div>
        </div>
      </section>

      <GenderPopup
        open={showInfo}
        onClose={handleClose}
        onExplore={handleExplore}
        transformOrigin={clickOrigin}
      />
    </div>
  );
};

export default GenderDetail;
